import React, { useCallback } from 'react';

import { useRouter } from 'expo-router';
import { useAppTakeoverPdp } from 'features/app-takeover/hooks/use-app-takeover';

import { ComboSlotType } from 'components/product-detail-v2/product-customization/ComboSlotType';
import { useProductWizardContext } from 'state/product-wizard-v2';
import useProductWizardFlow from 'state/product-wizard-v2/hooks/use-product-wizard-flow';
import { ProductWizardStep } from 'state/product-wizard-v2/types';
import { primitive } from 'styles/constants';

import { ProductDetailBackArrow } from '../product-detail-back-arrow';
import { ProductDetailClose } from '../product-detail-close';
import { ProductDetailFlowHeaderContainer } from '../styled';

import { Container, ProductTitle } from './styled';
import { useProductDetailHeader } from './use-product-detail-header';

interface IProductDetailHeader {
  currentStep: ProductWizardStep;
  comboSlotType?: ComboSlotType;
  onPress?: () => void;
  backgroundColor?: string;
  title?: string;
  eventAttributes?: { [key: string]: string };
  backNavigationLabel?: string;
}

export const ProductDetailHeader: React.FC<IProductDetailHeader> = ({
  currentStep,
  comboSlotType,
  onPress,
  backgroundColor,
  title,
  eventAttributes = {},
  backNavigationLabel = '',
}) => {
  const router = useRouter();
  const { isProductReviewFromCart, id } = useProductWizardFlow();
  const {
    headerBackgroundColor: takeoverHeaderBg,
    fontFamily: takeoverFontFamily,
    headerFontColor: takeoverHeaderFontColor,
    HeaderFlair,
  } = useAppTakeoverPdp(id);
  const { handleCloseDialog } = useProductWizardContext();

  const {
    headerTitleByProductWizardState,
    showCloseButton,
    showBackArrow,
  } = useProductDetailHeader(comboSlotType);

  const onDismiss = useCallback(() => {
    if (isProductReviewFromCart) {
      return router.dismiss();
    }

    if (currentStep === ProductWizardStep.ProductHome) {
      return router.dismiss();
    }
    handleCloseDialog(true);
  }, [isProductReviewFromCart, currentStep, handleCloseDialog, router]);

  return (
    <ProductDetailFlowHeaderContainer
      testID="product-detail-flow-header"
      backgroundColor={
        takeoverHeaderBg ||
        backgroundColor ||
        (currentStep === ProductWizardStep.ProductHome ? primitive.$mayoEggWhite : undefined)
      }
    >
      {HeaderFlair && <HeaderFlair />}
      <Container>
        {showBackArrow && onPress && (
          <ProductDetailBackArrow
            onPress={onPress}
            eventAttributes={eventAttributes}
            backNavigationLabel={backNavigationLabel}
            color={takeoverHeaderFontColor}
          />
        )}
        {showCloseButton && (
          <ProductDetailClose
            onDismiss={onDismiss}
            eventAttributes={eventAttributes}
            color={takeoverHeaderFontColor}
          />
        )}
        <ProductTitle
          fontFamily={takeoverFontFamily as 'heading' | 'body' | undefined}
          color={takeoverHeaderFontColor}
        >
          {title ? title : headerTitleByProductWizardState}
        </ProductTitle>
      </Container>
    </ProductDetailFlowHeaderContainer>
  );
};
